import { useCallback, useEffect, useState } from 'react'
import { consumeEmailVerificationRequiredNotice } from '../utils/auth0EmailVerification'

/** Opens the registration confirmation modal after Auth0 redirect blocked an unverified user. */
export function useEmailVerificationRequiredModal() {
  const [open, setOpen] = useState(false)

  useEffect(() => {
    if (consumeEmailVerificationRequiredNotice()) {
      setOpen(true)
    }
  }, [])

  const show = useCallback(() => setOpen(true), [])
  const dismiss = useCallback(() => setOpen(false), [])

  return {
    open,
    dismiss,
    show,
  }
}
